import { createApiClient, type ApiClient } from '@collector/api-client'

let _client: ApiClient | null = null

/**
 * Single shared API client. The dev server proxies /api -> :3000; in
 * production the SPA is served by the same Caddy instance that fronts the
 * API, so a relative baseURL works in both setups.
 */
export function api(): ApiClient {
  _client ??= createApiClient({
    baseURL: '/api',
    withCredentials: true,
  })
  return _client
}
